<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Hủy yêu đặt phòng khách sạn
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Hủy yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";
  import utils from "../../../services/utils";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import constants from "../../../constants";

  export default {
    name: "hc-ks-cancel-dialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "id"],
    components: {
      CustomDialog
    },

    data() {
      return {
        rules: {
          note: null
        },
        form: {
          note: null
        },
        hcCaseHotel: null
      };
    },

    computed: {},

    watch: {},

    async created() {
      this.initValidationRules();
      await this.loadHcCaseHotel();
      this.initFormForEdit();
    },

    methods: {
      initFormForEdit() {
        this.form.note = this.hcCaseHotel.note;
      },

      loadHcCaseHotel() {
        return hcCaseHotelService
          .findById(this.id)
          .then(response => (this.hcCaseHotel = response.data));
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        this.rules.note = [defaultRequiredConstrains];
      },

      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      convertToSubmitForm() {
        return {
          action: constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.HUY,
          caseMasterId: this.hcCaseHotel.caseMasterId,
          note: this.form.note
        };
      },

      submit() {
        return this.validateForm()
          .then(() =>
            utils.confirm(
              this.$confirm,
              errorMessageFilter({errorCode: "hcHotel.cancel.confirm"})
            )
          )
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hcCaseHotelService
              .cancel(submitForm)
              .then(response => response.data)
              .then(hcCaseHotel => {
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "hcHotel.cancelSuccess"
                  })
                );
                this.$emit("cancelSuccess", {result: hcCaseHotel});
              })
              .catch(error => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-cancel-dialog.vue